import { render, staticRenderFns } from "./TestingNotes.vue?vue&type=template&id=06ef3343"
import script from "./TestingNotes.vue?vue&type=script&lang=js"
export * from "./TestingNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports